import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "flex flex-col" };
const _hoisted_2 = ["src"];
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("path", {
    d: "M-.04 10c0-5.523 4.477-10 10-10h660c5.523 0 10 4.477 10 10v206h-680V10z",
    fill: "#FF7645"
}, null, -1);
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("path", {
    d: "M9.112 163.965c-.622 0-1.127.504-1.127 1.126h1.127v-1.126zm670.099 0H9.111v1.126h670.1v-1.126zm1.126 1.126c0-.621-.504-1.126-1.126-1.126v1.126h1.126zm-1.126 1.127c.622 0 1.126-.505 1.126-1.127h-1.126v1.127zm-670.1 0h670.1v-1.127H9.111v1.127zm-1.126-1.127c0 .622.505 1.127 1.127 1.127v-1.127H7.985zM.987 193.81c-.622 0-1.126.504-1.126 1.126H.987v-1.126zm678.224 0H.987v1.126h678.224v-1.126zm1.126 1.126c0-.622-.504-1.126-1.126-1.126v1.126h1.126zm-1.126 1.126c.622 0 1.126-.504 1.126-1.126h-1.126v1.126zm-678.224 0h678.224v-1.126H.987v1.126zm-1.126-1.126c0 .622.504 1.126 1.126 1.126v-1.126H-.139zm1.126-60.815c-.622 0-1.126.504-1.126 1.126H.987v-1.126zm670.099 0H.987v1.126h670.099v-1.126zm1.127 1.126c0-.622-.504-1.126-1.127-1.126v1.126h1.127zm-1.127 1.126c.623 0 1.127-.504 1.127-1.126h-1.127v1.126zm-670.099 0h670.099v-1.126H.987v1.126zm-1.126-1.126c0 .622.504 1.126 1.126 1.126v-1.126H-.139zm1.126-30.126c-.622 0-1.126.504-1.126 1.126H.987v-1.126zm670.099 0H.987v1.126h670.099v-1.126zm1.127 1.126c0-.622-.504-1.126-1.127-1.126v1.126h1.127zm-1.127 1.126c.623 0 1.127-.504 1.127-1.126h-1.127v1.126zm-670.099 0h670.099v-1.126H.987v1.126zm-1.126-1.126c0 .622.504 1.126 1.126 1.126v-1.126H-.139z",
    fill: "#DD653F"
}, null, -1);
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M151.233 108.694a1.371 1.371 0 10.001-2.743 1.371 1.371 0 00-.001 2.743zm-28.801 0a1.371 1.371 0 10.001-2.743 1.371 1.371 0 00-.001 2.743zm-49.373 0a1.371 1.371 0 100-2.743 1.371 1.371 0 000 2.743zm20.573 0a1.371 1.371 0 100-2.743 1.371 1.371 0 000 2.743zm-35.659 0a1.371 1.371 0 100-2.743 1.371 1.371 0 000 2.743zm-43.887 0a1.371 1.371 0 100-2.743 1.371 1.371 0 000 2.743zm222.179 4.114a1.371 1.371 0 100-2.742 1.371 1.371 0 000 2.742zM95.003 123.78a1.371 1.371 0 100-2.743 1.371 1.371 0 000 2.743zm-16.458 0a1.371 1.371 0 100-2.743 1.371 1.371 0 000 2.743zm-42.515 0a1.371 1.371 0 100-2.743 1.371 1.371 0 000 2.743zm101.489 0a1.371 1.371 0 100-2.742 1.371 1.371 0 000 2.742zm120.689 2.743a1.371 1.371 0 10.001-2.743 1.371 1.371 0 00-.001 2.743zm-200.235 4.115a1.372 1.372 0 100-2.743 1.372 1.372 0 000 2.743zm13.715 6.857a1.372 1.372 0 100-2.743 1.372 1.372 0 000 2.743zM.371 130.638a1.372 1.372 0 100-2.743 1.372 1.372 0 000 2.743zm122.061 0a1.372 1.372 0 100-2.743 1.372 1.372 0 000 2.743zm171.434 2.743a1.372 1.372 0 100-2.743 1.372 1.372 0 000 2.743zm-28.801 0a1.372 1.372 0 100-2.743 1.372 1.372 0 000 2.743zm-50.744 0a1.372 1.372 0 100-2.743 1.372 1.372 0 000 2.743zm-56.23 4.114a1.371 1.371 0 100-2.743 1.371 1.371 0 000 2.743zm-15.086 0a1.371 1.371 0 100-2.743 1.371 1.371 0 000 2.743zm-42.516 0a1.371 1.371 0 100-2.743 1.371 1.371 0 000 2.743zm101.489 0a1.371 1.371 0 100-2.743 1.371 1.371 0 000 2.743zm76.802 10.972a1.372 1.372 0 100-2.743 1.372 1.372 0 000 2.743zm-42.515 0a1.371 1.371 0 100-2.743 1.371 1.371 0 000 2.743zm-178.292 4.114a1.371 1.371 0 100-2.743 1.371 1.371 0 000 2.743zm79.546 0a1.371 1.371 0 100-2.742 1.371 1.371 0 000 2.742zm-58.974 13.715a1.372 1.372 0 100-2.743 1.372 1.372 0 000 2.743zM.371 152.581a1.371 1.371 0 100-2.743 1.371 1.371 0 000 2.743zm28.801 0a1.371 1.371 0 100-2.743 1.371 1.371 0 000 2.743zm57.602 0a1.371 1.371 0 100-2.743 1.371 1.371 0 000 2.743zm178.291 2.743a1.371 1.371 0 10.001-2.743 1.371 1.371 0 00-.001 2.743zm-64.459 0a1.371 1.371 0 10.001-2.743 1.371 1.371 0 00-.001 2.743zm-20.572 4.115a1.372 1.372 0 100-2.745 1.372 1.372 0 000 2.745zm-64.459 0a1.372 1.372 0 100-2.745 1.372 1.372 0 000 2.745zm6.857 6.857a1.372 1.372 0 100-2.743 1.372 1.372 0 000 2.743zm178.292-4.115a1.371 1.371 0 100-2.742 1.371 1.371 0 000 2.742zm-106.975 4.115a1.371 1.371 0 100-2.743 1.371 1.371 0 000 2.743zm-35.658 6.857a1.371 1.371 0 100-2.742 1.371 1.371 0 000 2.742zm-20.572 0a1.371 1.371 0 100-2.742 1.371 1.371 0 000 2.742zm-37.03 0a1.371 1.371 0 100-2.742 1.371 1.371 0 000 2.742zm178.291 4.115a1.372 1.372 0 100-2.743 1.372 1.372 0 000 2.743zm-49.373 0a1.372 1.372 0 100-2.743 1.372 1.372 0 000 2.743zm-28.801 0a1.372 1.372 0 100-2.743 1.372 1.372 0 000 2.743zm-185.148 4.114a1.371 1.371 0 100-2.743 1.371 1.371 0 000 2.743zm200.235 0a1.371 1.371 0 100-2.742 1.371 1.371 0 000 2.742zm-120.69 0a1.371 1.371 0 100-2.743 1.371 1.371 0 000 2.743zm-50.744 0a1.371 1.371 0 100-2.743 1.371 1.371 0 000 2.743zm278.408 2.743a1.371 1.371 0 10.001-2.743 1.371 1.371 0 00-.001 2.743zm-71.316 4.114a1.371 1.371 0 100-2.742 1.371 1.371 0 000 2.742zm-78.174 0a1.371 1.371 0 100-2.742 1.371 1.371 0 000 2.742zm49.373 0a1.371 1.371 0 100-2.742 1.371 1.371 0 000 2.742zm-106.975 6.858a1.372 1.372 0 100-2.743 1.372 1.372 0 000 2.743zm42.516 0a1.371 1.371 0 100-2.743 1.371 1.371 0 000 2.743zm142.633 2.743a1.371 1.371 0 100-2.743 1.371 1.371 0 000 2.743zm-220.807 4.114a1.371 1.371 0 100-2.743 1.371 1.371 0 000 2.743zm-64.46 0a1.371 1.371 0 100-2.743 1.371 1.371 0 000 2.743zm178.292 0a1.371 1.371 0 100-2.742 1.371 1.371 0 000 2.742zm43.887 0a1.372 1.372 0 100-2.744 1.372 1.372 0 000 2.744zm-186.52 6.857a1.371 1.371 0 100-2.743 1.371 1.371 0 000 2.743zm171.434 0a1.371 1.371 0 100-2.742 1.371 1.371 0 000 2.742zm-64.459 0a1.371 1.371 0 100-2.742 1.371 1.371 0 000 2.742zm-63.088 0a1.371 1.371 0 100-2.743 1.371 1.371 0 000 2.743zM503.702 203.603a1.371 1.371 0 110 2.742 1.371 1.371 0 010-2.742zm-42.516 0a1.371 1.371 0 110 2.742 1.371 1.371 0 010-2.742zm-178.291-4.115a1.372 1.372 0 11-.002 2.744 1.372 1.372 0 01.002-2.744zm79.545 0a1.372 1.372 0 110 2.745 1.372 1.372 0 010-2.745zm-58.973-13.714a1.371 1.371 0 110 2.742 1.371 1.371 0 010-2.742zm-78.174 13.714a1.372 1.372 0 11-.002 2.744 1.372 1.372 0 01.002-2.744zm28.801 0a1.372 1.372 0 11-.002 2.744 1.372 1.372 0 01.002-2.744zm57.602 0a1.372 1.372 0 11-.002 2.744 1.372 1.372 0 01.002-2.744zm178.291-2.742a1.371 1.371 0 110 2.742 1.371 1.371 0 010-2.742zm-64.459 0a1.371 1.371 0 110 2.742 1.371 1.371 0 010-2.742zm-20.572-4.115a1.371 1.371 0 110 2.743 1.371 1.371 0 010-2.743zm-64.46 0a1.372 1.372 0 110 2.743 1.372 1.372 0 010-2.743zm6.858-6.857a1.371 1.371 0 110 2.742 1.371 1.371 0 010-2.742zm178.291 4.114a1.372 1.372 0 110 2.743 1.372 1.372 0 010-2.743zm-106.975-4.114a1.371 1.371 0 11.001 2.743 1.371 1.371 0 01-.001-2.743zm-35.658-6.858a1.372 1.372 0 110 2.743 1.372 1.372 0 010-2.743zm-20.572 0a1.372 1.372 0 110 2.743 1.372 1.372 0 010-2.743zm-37.03 0a1.372 1.372 0 110 2.743 1.372 1.372 0 010-2.743zm178.292-4.114a1.371 1.371 0 110 2.742 1.371 1.371 0 010-2.742zm-49.373 0a1.371 1.371 0 110 2.742 1.371 1.371 0 010-2.742zm-28.801 0a1.371 1.371 0 110 2.742 1.371 1.371 0 010-2.742zm-185.149-4.114a1.372 1.372 0 110 2.744 1.372 1.372 0 010-2.744zm200.235 0a1.371 1.371 0 110 2.742 1.371 1.371 0 010-2.742zm-120.69 0a1.371 1.371 0 11.001 2.743 1.371 1.371 0 01-.001-2.743zm-50.744 0a1.371 1.371 0 110 2.742 1.371 1.371 0 010-2.742zm278.409-2.743a1.371 1.371 0 110 2.742 1.371 1.371 0 010-2.742zm-71.317-4.115a1.372 1.372 0 110 2.743 1.372 1.372 0 010-2.743zm-78.174 0a1.372 1.372 0 110 2.743 1.372 1.372 0 010-2.743zm49.373 0a1.372 1.372 0 110 2.743 1.372 1.372 0 010-2.743zm-106.975-6.857a1.371 1.371 0 11.001 2.743 1.371 1.371 0 01-.001-2.743zm42.516 0a1.371 1.371 0 11.001 2.743 1.371 1.371 0 01-.001-2.743zm142.633-2.743a1.371 1.371 0 11.001 2.743 1.371 1.371 0 01-.001-2.743zm-220.807-4.115a1.372 1.372 0 110 2.745 1.372 1.372 0 010-2.745zm-64.459 0a1.372 1.372 0 110 2.742 1.372 1.372 0 010-2.742zm178.291 0a1.372 1.372 0 110 2.745 1.372 1.372 0 010-2.745zm43.888 0a1.372 1.372 0 11-.002 2.744 1.372 1.372 0 01.002-2.744zm-186.521-6.857a1.372 1.372 0 110 2.743 1.372 1.372 0 010-2.743zm171.434 0a1.372 1.372 0 110 2.743 1.372 1.372 0 010-2.743zm-64.459 0a1.372 1.372 0 110 2.743 1.372 1.372 0 010-2.743zm-63.088 0a1.372 1.372 0 110 2.743 1.372 1.372 0 010-2.743zm207.093-8.229a1.371 1.371 0 110 2.743 1.371 1.371 0 010-2.743zm-43.887 0a1.371 1.371 0 110 2.743 1.371 1.371 0 010-2.743zm-149.491-6.857a1.371 1.371 0 11.001 2.743 1.371 1.371 0 01-.001-2.743zm-28.801 0a1.371 1.371 0 11.001 2.743 1.371 1.371 0 01-.001-2.743zm-49.373 0a1.371 1.371 0 11.001 2.743 1.371 1.371 0 01-.001-2.743zm42.516-6.857a1.371 1.371 0 110 2.742 1.371 1.371 0 010-2.742zm164.577 0a1.371 1.371 0 110 2.742 1.371 1.371 0 010-2.742zm-50.745 0a1.371 1.371 0 110 2.742 1.371 1.371 0 010-2.742zm-28.801 0a1.371 1.371 0 11.001 2.743 1.371 1.371 0 01-.001-2.743zm122.061-6.858a1.372 1.372 0 110 2.743 1.372 1.372 0 010-2.743zM276.037 107.6a1.371 1.371 0 11.001 2.743 1.371 1.371 0 01-.001-2.743zM526.933 199.488a1.372 1.372 0 110 2.745 1.372 1.372 0 010-2.745zm79.546 0a1.372 1.372 0 11-.002 2.744 1.372 1.372 0 01.002-2.744zm-58.973-13.714a1.371 1.371 0 110 2.742 1.371 1.371 0 010-2.742zm-78.174 13.714a1.372 1.372 0 11-.002 2.744 1.372 1.372 0 01.002-2.744zm28.8 0a1.372 1.372 0 110 2.745 1.372 1.372 0 010-2.745zm57.602 0a1.372 1.372 0 110 2.745 1.372 1.372 0 010-2.745zm113.832-2.742a1.371 1.371 0 11.001 2.743 1.371 1.371 0 01-.001-2.743zm-20.571-4.115a1.371 1.371 0 110 2.743 1.371 1.371 0 010-2.743zm-64.46 0a1.372 1.372 0 110 2.743 1.372 1.372 0 010-2.743zm6.858-6.857a1.371 1.371 0 110 2.742 1.371 1.371 0 010-2.742zm71.316 0a1.371 1.371 0 11.001 2.743 1.371 1.371 0 01-.001-2.743zm-35.658-6.858a1.372 1.372 0 110 2.745 1.372 1.372 0 010-2.745zm-20.572 0a1.371 1.371 0 110 2.743 1.371 1.371 0 010-2.743zm-37.03 0a1.372 1.372 0 110 2.743 1.372 1.372 0 010-2.743zm100.117-4.114a1.371 1.371 0 11.001 2.743 1.371 1.371 0 01-.001-2.743zm-185.148-4.114a1.371 1.371 0 110 2.742 1.371 1.371 0 010-2.742zm79.545 0a1.371 1.371 0 11.001 2.743 1.371 1.371 0 01-.001-2.743zm-50.744 0a1.371 1.371 0 110 2.742 1.371 1.371 0 010-2.742zm128.918-6.858a1.372 1.372 0 110 2.743 1.372 1.372 0 010-2.743zm-57.602-6.857a1.371 1.371 0 11.001 2.743 1.371 1.371 0 01-.001-2.743zm42.516 0a1.372 1.372 0 110 2.744 1.372 1.372 0 010-2.744zm-78.174-6.858a1.372 1.372 0 110 2.745 1.372 1.372 0 010-2.745zm-64.459 0a1.372 1.372 0 11-.002 2.744 1.372 1.372 0 01.002-2.744zm178.291 0a1.372 1.372 0 110 2.745 1.372 1.372 0 010-2.745zm-142.633-6.857a1.372 1.372 0 110 2.743 1.372 1.372 0 010-2.743zm106.975 0a1.372 1.372 0 110 2.745 1.372 1.372 0 010-2.745zm-49.373-15.086a1.371 1.371 0 110 2.742 1.371 1.371 0 010-2.742zm-28.801 0a1.371 1.371 0 11.001 2.743 1.371 1.371 0 01-.001-2.743zm-49.373 0a1.371 1.371 0 110 2.742 1.371 1.371 0 010-2.742zm42.516-6.857a1.371 1.371 0 110 2.742 1.371 1.371 0 010-2.742zm113.832 0a1.371 1.371 0 110 2.742 1.371 1.371 0 010-2.742zm-28.801 0a1.372 1.372 0 110 2.744 1.372 1.372 0 010-2.744zM520.076 107.6a1.371 1.371 0 11.001 2.743 1.371 1.371 0 01-.001-2.743z",
    fill: "#DD653F"
}, null, -1);
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M414.58 216l71.784-109.788h25.439L444.524 216H414.58z",
    fill: "#DDDBEA",
    stroke: "#DDDBEA",
    "stroke-width": "1.126",
    "stroke-linejoin": "round"
}, null, -1);
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M414.016 214.628L485.8 104.839l25.44.001-67.28 109.788h-29.944z",
    fill: "#F7F7FF",
    stroke: "#F7F7FF",
    "stroke-width": "1.126",
    "stroke-linejoin": "round"
}, null, -1);
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M439.472 44.696c.608-6.94 6.726-12.073 13.665-11.466l5.386.47c9.914.868 17.247 9.608 16.38 19.522l-.054.62c-.144 1.64 1.1 3.09 2.74 3.233 1.388.121 2.704-.715 3.158-2.032l.196-.569a5.71 5.71 0 015.895-3.825l1.503.131a5.094 5.094 0 014.646 5.265l-2.228 59.703a7.207 7.207 0 01-7.831 6.911l-41.581-3.638c-4.382-.383-7.401-4.567-6.384-8.846l12.385-52.128a9.01 9.01 0 01-8.19-9.761l.314-3.59z",
    fill: "#67D1E1",
    stroke: "#67D1E1",
    "stroke-width": ".282"
}, null, -1);
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("path", {
    d: "M467.619 66.668l.009-.064a.675.675 0 011.349.053l-.003.065a.675.675 0 101.346.118 2.027 2.027 0 10-4.039-.354.677.677 0 001.338.182zM478.389 67.61l.009-.064a.675.675 0 011.349.053l-.003.065a.676.676 0 001.347.118 2.028 2.028 0 00-4.039-.354.675.675 0 001.337.183zM478.777 70.97c.371.033.646.361.614.733a6.081 6.081 0 11-12.117-1.06.676.676 0 01.732-.614l10.771.942z",
    fill: "#00292B"
}, null, -1);
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("rect", {
    x: "439.164",
    y: "37.886",
    width: "37.841",
    height: "7.883",
    rx: ".901",
    transform: "rotate(5 439.164 37.886)",
    fill: "#F7F7FF"
}, null, -1);
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("g", {
    style: { "mix-blend-mode": "multiply" },
    stroke: "#BBB7D5",
    "stroke-width": ".563"
}, [
    /*#__PURE__*/ _createElementVNode("path", {
        "clip-rule": "evenodd",
        d: "M493.642 70.75a1.127 1.127 0 01.959-1.272l4.461-.627a1.126 1.126 0 011.272.958l.289 2.059c.016.114.014.23-.005.343l-.222 1.322c-.038.228-.005.463.095.672l.499 1.046c.1.208.133.443.095.671l-.192 1.143c-.039.228-.006.463.094.672l.499 1.045c.1.209.133.444.095.672l-.192 1.143c-.038.228-.005.462.095.671l.577 1.21c.05.104.083.215.099.329l.368 2.616a1.127 1.127 0 01-.959 1.272l-4.461.627a1.126 1.126 0 01-1.272-.959l-.367-2.616a1.128 1.128 0 01.004-.343l.222-1.322a1.126 1.126 0 00-.094-.672l-.5-1.046a1.134 1.134 0 01-.094-.671l.192-1.143a1.127 1.127 0 00-.095-.672l-.499-1.045a1.119 1.119 0 01-.094-.672l.192-1.143a1.127 1.127 0 00-.095-.671l-.578-1.21a1.143 1.143 0 01-.099-.329l-.289-2.058z"
    }),
    /*#__PURE__*/ _createElementVNode("path", { d: "M495.001 68.284l3.346-.47.157 1.115-3.346.47z" })
], -1);
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("ellipse", {
    cx: "495.191",
    cy: "81.33",
    rx: "3.66",
    ry: "1.83",
    transform: "rotate(-88 495.191 81.33)",
    fill: "#67D1E1",
    stroke: "#67D1E1",
    "stroke-width": "1.505",
    "stroke-linejoin": "round"
}, null, -1);
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M190.041 103.759a6.942 6.942 0 0113.872-.452l.518 9.882a2.269 2.269 0 104.531-.238l-.525-10.016a6.806 6.806 0 0113.594-.713l.536 10.242a2.27 2.27 0 004.532-.237l-.537-10.242a6.806 6.806 0 1113.593-.712l.525 10.016a2.27 2.27 0 004.532-.238l-.518-9.881a6.94 6.94 0 0113.843-1.001l1.32 14.328c1.819 19.728-13.133 37.009-32.917 38.046-19.784 1.037-36.461-14.587-36.715-34.396l-.184-14.388z",
    fill: "#904C6F"
}, null, -1);
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("path", {
    d: "M239.955 132.214a4.715 4.715 0 00-2.714.052 4.709 4.709 0 00-2.246 1.56.676.676 0 01-1.06-.838 6.057 6.057 0 016.378-2.077.676.676 0 11-.358 1.303z",
    fill: "#00292B"
}, null, -1);
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("circle", {
    cx: "229.285",
    cy: "124.8",
    r: ".901",
    transform: "rotate(-3 229.285 124.8)",
    fill: "#00292B"
}, null, -1);
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("circle", {
    cx: "240.081",
    cy: "124.234",
    r: ".901",
    transform: "rotate(-3 240.081 124.234)",
    fill: "#00292B"
}, null, -1);
const _hoisted_17 = /*#__PURE__*/ _createElementVNode("path", {
    d: "M241.592 122.15l-.128.042c-.084.027-.178.056-.283.087l-.108.032a26.48 26.48 0 01-1.455.378 27.874 27.874 0 01-4.805.693c-1.641.086-3.359.011-5.048-.175a35.94 35.94 0 01-1.411-.184l-.335-.053-.474-.083a.676.676 0 00-.261 1.326l.173.032a35.526 35.526 0 002.16.305c1.756.194 3.545.272 5.267.182a29.318 29.318 0 005.038-.726c.484-.112.93-.227 1.333-.341l.197-.057.327-.098.25-.081a.675.675 0 00-.437-1.279z",
    fill: "#00292B"
}, null, -1);
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("rect", {
    x: "188.944",
    y: "103.908",
    width: "15.316",
    height: "7.883",
    rx: ".901",
    transform: "rotate(-3 188.944 103.908)",
    fill: "#F7F7FF"
}, null, -1);
const _hoisted_19 = /*#__PURE__*/ _createElementVNode("rect", {
    x: "207.388",
    y: "102.941",
    width: "15.316",
    height: "7.883",
    rx: ".901",
    transform: "rotate(-3 207.388 102.941)",
    fill: "#F7F7FF"
}, null, -1);
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("rect", {
    x: "225.833",
    y: "101.974",
    width: "15.316",
    height: "7.883",
    rx: ".901",
    transform: "rotate(-3 225.833 101.974)",
    fill: "#F7F7FF"
}, null, -1);
const _hoisted_21 = /*#__PURE__*/ _createElementVNode("rect", {
    x: "244.277",
    y: "101.008",
    width: "15.316",
    height: "7.883",
    rx: ".901",
    transform: "rotate(-3 244.277 101.008)",
    fill: "#F7F7FF"
}, null, -1);
const _hoisted_22 = /*#__PURE__*/ _createElementVNode("ellipse", {
    cx: "211.105",
    cy: "127.927",
    rx: "1.126",
    ry: "1.689",
    stroke: "#F7F7FF",
    "stroke-width": ".563"
}, null, -1);
const _hoisted_23 = /*#__PURE__*/ _createElementVNode("ellipse", {
    cx: "215.609",
    cy: "122.296",
    rx: "1.126",
    ry: "1.689",
    stroke: "#F7F7FF",
    "stroke-width": ".563"
}, null, -1);
const _hoisted_24 = /*#__PURE__*/ _createElementVNode("ellipse", {
    cx: "249.959",
    cy: "115.538",
    rx: "1.126",
    ry: "1.689",
    stroke: "#F7F7FF",
    "stroke-width": ".563"
}, null, -1);
const _hoisted_25 = /*#__PURE__*/ _createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M209.857 104.071a.563.563 0 11.195 1.11.563.563 0 01-.195-1.11zM211.322 106.12a.563.563 0 11.196 1.108.563.563 0 01-.196-1.108zM209.918 108.053a.563.563 0 11.196 1.108.563.563 0 01-.196-1.108zM247.022 101.819a.564.564 0 11.195 1.112.564.564 0 01-.195-1.112zM248.487 103.868a.563.563 0 11.196 1.108.563.563 0 01-.196-1.108zM247.083 105.8a.563.563 0 11.195 1.11.563.563 0 01-.195-1.11zM227.904 103.291a.563.563 0 11.195 1.11.563.563 0 01-.195-1.11zM229.898 102.66a.563.563 0 11.196 1.108.563.563 0 01-.196-1.108zM227.964 107.272a.564.564 0 11.195 1.112.564.564 0 01-.195-1.112z",
    fill: "#DDDBEA"
}, null, -1);
const _hoisted_26 = /*#__PURE__*/ _createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M365.323 123.277c-.08-8.922 7.883-15.773 16.693-14.362l23.175 3.709a14.416 14.416 0 0112.062 12.762l5.466 53.241a7.208 7.208 0 01-6.793 7.934l-42.498 2.227a7.208 7.208 0 01-7.585-7.134l-.52-58.377z",
    fill: "#FFD220"
}, null, -1);
const _hoisted_27 = /*#__PURE__*/ _createElementVNode("circle", {
    cx: "395.377",
    cy: "131.701",
    r: ".901",
    transform: "rotate(-3 395.377 131.701)",
    fill: "#00292B"
}, null, -1);
const _hoisted_28 = /*#__PURE__*/ _createElementVNode("circle", {
    cx: "406.174",
    cy: "131.135",
    r: ".901",
    transform: "rotate(-3 406.174 131.135)",
    fill: "#00292B"
}, null, -1);
const _hoisted_29 = /*#__PURE__*/ _createElementVNode("path", {
    d: "M400.976 135.242c1.437-.075 2.555 1.425 2.651 3.244.095 1.82-.86 3.429-2.298 3.504-1.438.075-2.555-1.425-2.651-3.244-.095-1.82.86-3.429 2.298-3.504z",
    fill: "#00292B"
}, null, -1);
const _hoisted_30 = /*#__PURE__*/ _createElementVNode("rect", {
    x: "364.552",
    y: "120.234",
    width: "52.707",
    height: "7.883",
    rx: ".901",
    transform: "rotate(-3 364.552 120.234)",
    fill: "#F7F7FF"
}, null, -1);
const _hoisted_31 = /*#__PURE__*/ _createElementVNode("ellipse", {
    cx: "370.463",
    cy: "140.315",
    rx: "1.126",
    ry: "1.689",
    stroke: "#F7F7FF",
    "stroke-width": ".563"
}, null, -1);
const _hoisted_32 = /*#__PURE__*/ _createElementVNode("ellipse", {
    cx: "372.716",
    cy: "134.121",
    rx: "1.126",
    ry: "1.689",
    stroke: "#F7F7FF",
    "stroke-width": ".563"
}, null, -1);
const _hoisted_33 = /*#__PURE__*/ _createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M366.428 121.874a.563.563 0 11.196 1.108.563.563 0 01-.196-1.108zM368.422 121.242a.563.563 0 11.195 1.11.563.563 0 01-.195-1.11zM366.488 125.855a.563.563 0 11.196 1.108.563.563 0 01-.196-1.108z",
    fill: "#DDDBEA"
}, null, -1);
const _hoisted_34 = [
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _hoisted_6,
    _hoisted_7,
    _hoisted_8,
    _hoisted_9,
    _hoisted_10,
    _hoisted_11,
    _hoisted_12,
    _hoisted_13,
    _hoisted_14,
    _hoisted_15,
    _hoisted_16,
    _hoisted_17,
    _hoisted_18,
    _hoisted_19,
    _hoisted_20,
    _hoisted_21,
    _hoisted_22,
    _hoisted_23,
    _hoisted_24,
    _hoisted_25,
    _hoisted_26,
    _hoisted_27,
    _hoisted_28,
    _hoisted_29,
    _hoisted_30,
    _hoisted_31,
    _hoisted_32,
    _hoisted_33
];
const _hoisted_35 = { class: "mt-4 mb-4 text-4xl font-bold text-center text-gray-900 -mx-14 m-w-xs dark:text-gray-300" };
const _hoisted_36 = { class: "self-center w-3/4 mb-4 text-sm font-normal text-gray-900 dark:text-gray-300" };
const _hoisted_37 = { class: "self-center w-3/4 mb-4 text-sm font-normal text-gray-900 dark:text-gray-300" };
const _hoisted_38 = { class: "self-center w-3/4 mb-4 text-sm font-normal text-gray-900 dark:text-gray-300" };
const _hoisted_39 = { class: "flex-row self-center w-3/4 mb-4 text-sm font-normal" };
const _hoisted_40 = { class: "mb-4 text-sm font-normal text-gray-900 dark:text-gray-300" };
const _hoisted_41 = {
    target: "_blank",
    rel: "noopener noreferrer",
    href: "https://www.linkedin.com/pulse/getting-most-out-your-retros-retroally/?trackingId=xzfL0S4cxf9ILPvfPWKBuQ%3D%3D",
    class: "text-orange-500 underline"
};
const _hoisted_42 = { class: "mb-4 text-sm font-normal text-gray-900 dark:text-gray-300" };
const _hoisted_43 = { class: "flex justify-between mx-8 mt-8 mb-4" };
const _hoisted_44 = { class: "flex flex-row max-h-6" };
const _hoisted_45 = { class: "mx-4 mb-8 text-sm font-normal text-gray-900 dark:text-gray-300" };
import componentI18n from '@/i18n/componentI18n';
const __default__ = {
    ...componentI18n('components.unlock_more_activities_dialog')
};
import Dialog from '@/components/Dialog.vue';
import Modal from '@/components/Modal.vue';
import NonFreeLabel from '@/components/pricing/NonFreeLabel.vue';
import transitions from '@/helpers/transitions';
export default /*#__PURE__*/ _defineComponent({
    ...__default__,
    __name: 'UnlockMoreActivitiesDialog',
    props: {
        isVisible: { type: Boolean }
    },
    emits: ['confirm'],
    setup(__props, { emit }) {
        const { scale } = transitions;
        const { scaleIn, scaleOut } = scale;
        const handleConfirm = () => {
            emit('confirm');
        };
        return (_ctx, _cache) => {
            const _component_PillButton = _resolveComponent("PillButton");
            const _component_TransitionA11y = _resolveComponent("TransitionA11y");
            return (_openBlock(), _createBlock(Modal, null, {
                default: _withCtx(() => [
                    _createVNode(_component_TransitionA11y, {
                        css: false,
                        enter: _unref(scaleIn),
                        leave: _unref(scaleOut),
                        class: "my-2"
                    }, {
                        default: _withCtx(() => [
                            (__props.isVisible)
                                ? (_openBlock(), _createBlock(Dialog, {
                                    key: 0,
                                    class: "z-50"
                                }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_1, [
                                            (_openBlock(), _createElementBlock("svg", {
                                                width: "680",
                                                height: "217",
                                                viewBox: "0 0 680 217",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                class: _normalizeClass('w-full h-full'),
                                                src: '@/assets/images/dudes-running-a-race.svg',
                                                "svg-inline": ''
                                            }, _hoisted_34, 8, _hoisted_2)),
                                            _createElementVNode("h4", _hoisted_35, _toDisplayString(_ctx.$t('title')), 1),
                                            _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.$t('activity')), 1),
                                            _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.$t('outcomes')), 1),
                                            _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.$t('helper')), 1),
                                            _createElementVNode("p", _hoisted_39, [
                                                _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.$t('check')) + " ", 1),
                                                _createElementVNode("a", _hoisted_41, _toDisplayString(_ctx.$t('article')), 1),
                                                _createElementVNode("span", _hoisted_42, "  " + _toDisplayString(_ctx.$t('more_information')), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_43, [
                                                _createElementVNode("div", _hoisted_44, [
                                                    _createVNode(NonFreeLabel),
                                                    _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.$t('upgrade')), 1)
                                                ]),
                                                _createVNode(_component_PillButton, { onClick: handleConfirm }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.$t('confirm')), 1)
                                                    ], undefined, true),
                                                    _: 1
                                                })
                                            ])
                                        ])
                                    ], undefined, true),
                                    _: 1
                                }))
                                : _createCommentVNode("", true)
                        ], undefined, true),
                        _: 1
                    }, 8, ["enter", "leave"])
                ], undefined, true),
                _: 1
            }));
        };
    }
});
